<template>
  <main class="main">
    <template v-if="submitted">
      <div class="content">
        <header-bar/>
        <div class="thanks">
          <h1>すでにご入力いただいております。</h1>
          <br>お申し込み内容に変更がある場合は、お電話でご連絡ください。
          <br>
          <br>電話：
          <template v-if="!ispc">
            <a href="tel:0120-945-991">0120-945-991</a>
          </template>
          <template v-else>0120-945-991</template>（年末年始除く
          <time>9:15～21:00</time>）
        </div>
      </div>
    </template>

    <template v-else-if="expired">
      <div class="content">
        <header-bar/>
        <div class="thanks">
          <h1>査定金額の有効期限が切れています</h1>
        </div>
      </div>
    </template>

    <template v-else-if="code_error">
      <div class="content">
        <header-bar/>
        <div class="thanks">
          <h1>無効なURL/無効な操作です。</h1>
        </div>
      </div>
    </template>

    <template v-if="!submitted && !expired && !code_error && !loading">
      <div v-if="templateType !== 'thanks' && !user_submitted" class="content">
        <header-bar :templateType="'info'"/>
        <div class="details">
          <dl>
            <dt>
              <span class="price">本査定額合計</span>
              <span class="sum">
                {{current_offer.total_price}}
                <small>円</small>
              </span>
              <p>
                <b>本査定額の有効期限：{{lifetime}}</b>
              </p>
              <p>
                <small>※内訳は明細をご覧ください</small>
              </p>
            </dt>
            <dd v-if="itemsWorth.length > 0">
              <b>［本査定明細］</b>
              <items-table :itemsSource="itemsWorth"></items-table>
            </dd>
            <dd v-if="itemsNotBuy.length > 0">
              <b>以下の商品はお買取できません</b>
              <items-table :itemsSource="itemsNotBuy"></items-table>
            </dd>
          </dl>
        </div>
        <!--/details-->
        <form-btns :templateType="'accept'"></form-btns>
        <form-btns :templateType="'tel'"></form-btns>
      </div>
      <div v-else-if="templateType !== 'thanks' && user_submitted">
        <div class="thanks">
          <h1>すでにご入力いただいております。</h1>
          <br>お申し込み内容に変更がある場合は、お電話でご連絡ください。
          <br>
          <br>電話：
          <template v-if="!ispc">
            <a href="tel:0120-945-991">0120-945-991</a>
          </template>
          <template v-else>0120-945-991</template>（年末年始除く
          <time>9:15～21:00</time>）
        </div>
      </div>
      <div v-else-if="templateType == 'thanks'" class="content">
        <header-bar/>
        <div class="thanks">
          <h1>送信が完了しました。</h1>
          <p>自動返信メールをお送りしましたのでご確認ください。</p>
        </div>
      </div>
      <!--/content-->
    </template>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import FormBtns from "@/components/FormBtns";
import HeaderBar from "@/components/HeaderBar";
import ItemsTable from "@/components/ItemsTable";
import utils from "../utils";
export default {
  data() {
    return {};
  },
  components: {
    FormBtns,
    HeaderBar,
    ItemsTable
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "ispc",
      "current_offer",
      "user_submitted",
      "submitted",
      "expired",
      "code_error",
      "loading"
    ]),
    itemsWorth() {
      return this.current_offer.items.filter(item => !item.not_buy);
    },
    itemsNotBuy() {
      return this.current_offer.items.filter(item => item.not_buy);
    },
    lifetime() {
      return this.tsToDeliveryDateLable(this.current_offer.created.$date);
    }
  },
  methods: {
    tsToDeliveryDateLable(ts) {
      const wNames = ["日", "月", "火", "水", "木", "金", "土"];

      let res = new Date((ts += (60*60*24*10)) * 1000);
      res.setHours(0, 0, 0, 0);
      res.setDate(res.getDate());
      const m = res.getMonth() + 1;
      const d = res.getDate();
      const w = res.getDay();

      return (
        ("0" + m).slice(-2) +
        "月" +
        ("0" + d).slice(-2) +
        "日 (" +
        wNames[w] +
        ")"
      );
    }
  },
  props: ["templateType"],
  name: "main-part"
};
</script>

<style lang="scss" scoped>
#honsatei {
  h1 {
    clear: both;
    font-size: 25px;
    letter-spacing: 1px;
    line-height: 1.5;
    margin: 10px 0 25px 0;
  }
  .content {
    box-sizing: border-box;
    clear: both;
    font-size: 15px;
    padding: 15px;
    position: relative;
    text-align: center;
    .logo {
      height: 61px;
      position: absolute;
      left: 0;
      top: 10px;
      width: 110px;
    }
  }

  .details {
    background-color: #fff;
    border: 1px solid #927f5e;
    border-radius: 8px;
    box-sizing: border-box;
    margin: 30px auto 30px auto !important;
    overflow: hidden;
    text-align: left;
    width: 100%;
    dl {
      background-color: #fff !important;
      border: 0 !important;
      clear: both;
      margin: 0;
      overflow: hidden;
      padding: 20px;
    }
    dt {
      float: left;
      font-size: 18px;
      padding: 0;
      text-align: left;
      width: 32%;
      p {
        clear: both;
        font-size: 15px;
        margin: 0;
        padding: 0;
        small {
          font-size: 14px;
        }
      }
      .price {
        background-color: #df4726;
        color: #fff;
        font-size: 15px;
        font-weight: normal;
        padding: 5px 10px;
      }
      .sum {
        color: #df4726;
        display: block;
        font-size: 50px;
        font-weight: bold;
        margin: 10px 0 5px 0;
        small {
          font-size: 25px;
        }
      }
    }
    dd {
      background: none !important;
      box-sizing: border-box;
      float: right;
      margin: 0;
      padding: 0;
      width: 68%;
      p {
        clear: both;
        margin: 0;
        padding: 0;
        small {
          color: #df4726;
          font-size: 13px;
          margin-right: 5px;
        }
      }
    }
  }

  /*thanks*/
  .thanks {
    clear: both;
    margin: 70px auto 30px auto;
    overflow: hidden;
  }
  .thanks h1 {
    margin: 0 !important;
  }
  .content #customer {
    max-width: 100%;
  }
  .content #customer h2 {
    line-height: 1.5;
  }
  .content .resend {
    background-color: #fff;
    border-radius: 10px;
    border: 6px solid #c8bfaf;
    margin: 0 auto 40px auto;
    overflow: hidden;
    padding: 30px 20px 15px 20px;
    width: 70%;
  }
  .content .resend .message {
    font-size: 16px;
    font-weight: bold;
    margin: 30px auto 0 auto;
    text-align: left;
    width: 90%;
  }
  .content .resend h2 {
    border-bottom: 1px solid #000;
    clear: both;
    display: inline;
    font-size: 18px;
    line-height: 2.3;
    padding-bottom: 10px;
  }
  .content .resend .form_btn_accept {
    margin: 30px auto;
    width: 70%;
  }
  /*/thanks*/
}
@media screen and (max-width: 1024px) {
  #honsatei {
    .details {
      margin: 20px auto !important;
    }
  }
}
@media screen and (min-width: 960px) and (max-width: 1023px) {
  #honsatei h1 {
    font-size: 18px;
    padding-top: 8px;
  }
  .details {
    dt {
      width: 38%;
    }
    dd {
      margin: 0;
      width: 62%;
    }
    p {
      text-align: left;
    }
  }
}
@media screen and (min-width: 601px) and (max-width: 959px) {
  #honsatei {
    .sp_only {
      display: none;
    }
    .pc_only {
      display: block;
    }
    .details {
      dt {
        width: 33%;
        .sum {
          font-size: 35px;
        }
      }
      dd {
        width: 65%;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  #honsatei {
    h1 {
      font-size: 4.4vw;
      letter-spacing: 0;
      margin: -5px auto 15px 0;
      padding-left: 80px;
    }
    h2 {
      font-size: 18px;
    }
    p {
      text-align: left;
    }
    .content {
      clear: both;
      font-size: 14px;
      margin-bottom: 0;
      padding: 15px;
      text-align: center;
      .logo {
        height: 43px;
        left: 10px;
        width: 77px;
      }
      p {
        padding: 0;
      }
    }
    .flow_h2 {
      margin: 40px 0 0 0;
    }
    .content #customer {
      margin: 0 !important;
      width: auto !important;
      p {
        padding: 10px 20px 0 20px;
      }
    }

    .thanks {
      margin: 50px auto 10px auto;
      h1 {
        font-size: 18px !important;
        padding-left: 0 !important;
      }
      p {
        font-size: 15px !important;
      }
    }

    .content .resend {
      padding: 20px 15px 10px 15px;
      width: auto;
      .message {
        text-align: left;
        width: auto;
      }
      .form_btn_accept {
        box-sizing: border-box;
        width: 100%;
      }
    }

    /*/form_btn_tel*/
    .details {
      dl {
        padding: 15px;
      }
      dt {
        box-sizing: border-box;
        font-size: 16px;
        width: 100%;
        img {
          margin-top: 0;
        }
        p {
          font-size: 14px;
        }
      }
      dd {
        margin-top: 15px;
        width: 100%;
        ul {
          font-size: 14px;
        }
      }
      .details_cnt {
        line-height: 1.3;
        span {
          padding: 5px;
        }
      }
      .details_ttl span:first-child,
      .details_cnt span:first-child {
        width: 30%;
      }
      .details_ttl span:nth-child(2),
      .details_cnt span:nth-child(2) {
        width: 15%;
      }
      .details_ttl span:nth-child(3),
      .details_cnt span:nth-child(3) {
        width: 25%;
      }
      .details_ttl span:nth-child(4),
      .details_cnt span:nth-child(4) {
        width: 30%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainPart.vue